<template>
<v-app>
  <prb-toolbar v-bind:disable="!terms"></prb-toolbar>
  <prb-terms v-bind:termsDialog="!terms"></prb-terms>
  <main>
    <v-container fluid>
      <v-layout class="faq__layout">
        <v-flex xs12>
          <div class="faq__layout-card">
            <v-card>
              <v-card-title class="pa-0">
                <div class="top__layout-title">FAQ</div>
              </v-card-title>
              <v-card-text>
                <span class="body-2">1. What is the difference between Probe Miner and the Chemical Probes Portal?</span>
                <p>Probe Miner provides computational and statistical assessment of compounds in the medicinal chemistry literature and scores them for their suitability as chemical probes for a certain target. The current version of Probe Miner analysed >1.8 million compounds and provides final scores for approx. 400,000 compounds against 2,220 human targets. The Chemical Probes Portal is an expert-curated resource. As a result, Probe Miner covers a much larger compound and target set, yet does not benefit from the expert annotation for those probes that are in the Chemical Probes Portal. The two resources are highly complementary. For best information to select a suitable probe, we recommend researchers use both resources in conjunction where targets or probes are provided in both.</p>
                <span class="body-2">2. How often is Probe Miner updated?</span>
                <p>Currently the underlying data and scores in Probe Miner are updated every three months. We plan more regular updates in future.</p>
                <span class="body-2">3. Is there a description of the scoring scheme?</span>
                <p>An article describing the methods and analysis has been uploaded to the preprint server <a href="http://www.biorxiv.org" target="_blank">bioRxiv</a>.</p>
                <span class="body-2">4. Why can’t I search for a probe?</span>
                <p>Probe Miner assesses all compounds for suitability as probes against each target. So the same compound may appear for multiple targets and score differently based on the values that relate it to the specific target. The purpose of Probe Miner is to provide an objective view on all possible probes for a particular target.</p>
                <span class="body-2">5. What does the ‘characterisation’ bar and value mean?</span>
                <p>A dilemma that we face in objective assessment of probes is the inequality of data available for different targets and compounds. We reward targets and compounds that have extensive experimental characterisations. The characterisation bar and value is a measure derived from the number of active compounds against a query target and the number of off-targets that these compounds have been tested against. The greater the characterisation value, the better.</p>
                <span class="body-2">6. I know a probe is available for my target but I cannot find it on Probe Miner.</span>
                <p>Probe Miner relies on data in the public medicinal chemistry resources such as ChEMBL, BindingDB etc. Unfortunately these resources often do not contain data from a few key chemical biology publications and can thus miss key compounds and publications.
                   Another possible reason is that the data relating to the specific compound may be mis-annotated or mis-curated.
                   In collaboration with our sister knowledgebase, <a v-bind:href="apiUrl" target="_blank">canSAR</a>,  we are undergoing an extensive curation and including new data.
                   If you are aware of key missing information or found an error, please let us know on <a href="mailto:chemprobes@icr.ac.uk">chemprobes@icr.ac.uk</a>
                </p>
                <span class="body-2">7. My probe has published data that Probe Miner says doesn’t exist.</span>
                <p>Probe Miner relies on data in the public medicinal chemistry resources such as ChEMBL, BindingDB etc. Unfortunately these resources often do not contain data from a few key chemical biology publications and can thus miss key compounds and publications.
                   Another possible reason is that the data relating to the specific compound may be mis-annotated or mis-curated.
                   In collaboration with our sister knowledgebase, <a v-bind:href="apiUrl" target="_blank">canSAR</a>,  we are undergoing an extensive curation and including new data.
                   If you are aware of key missing information or found an error, please let us know on <a href="mailto:chemprobes@icr.ac.uk">chemprobes@icr.ac.uk</a>
                </p>
              </v-card-text>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </main>
  <prb-footer></prb-footer>
</v-app>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import PrbToolbar from './prb-toolbar/PrbToolbar';
import PrbTerms from './prb-terms/PrbTerms';
import PrbFooter from './prb-footer/PrbFooter';

export default {
  components: {
    PrbToolbar,
    PrbTerms,
    PrbFooter
  },
  metaInfo: {
    title: 'Probe Miner',
    titleTemplate: '%s | FAQ'
  },
  computed: mapGetters([
    'termsVerified'
  ]),
  name: 'prbfaq',
  computed: {
    terms: {
      get() {
        return this.$store.state.termsVerified
      }
    }
  },
  data() {
    return {
      termsDialog: true,
      search: null,
      e1: 1,
      apiUrl: process.env.API_URL
    }
  }
}
</script>

<style scoped>
.faq__layout {
  height: 100%;
  background: url(../img/layer6.png) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.faq__layout-card {
  padding: 5% 5% 0 5%;
}
.top__layout-title{
  width: 100%;
  font-size: 30px;
  padding: 10px;
  font-weight: 300;
  background-color: #455A64;
  color: white;
  margin: 0 0 5px 0;
}
@media screen and (max-width: 1600px) {
  .faq__layout-card {
    padding: 2% 2% 0 2%;
  }
}
@media screen and (max-width: 800px) {
  .faq__layout-card {
    padding: 2% 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// PrbFaq.vue?0270bbb0